import { render, staticRenderFns } from "./ElectronicContractConfigure.vue?vue&type=template&id=2bb88c7e&scoped=true"
import script from "./ElectronicContractConfigure.vue?vue&type=script&lang=js"
export * from "./ElectronicContractConfigure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb88c7e",
  null
  
)

export default component.exports